import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

const { UI, Order, Menu } = Mobi2Go;
const { classNames } = Mobi2Go.helpers;

class ProductSuggestion extends React.Component {
    static propTypes = {
        action: PropTypes.string,
        category: PropTypes.shape({
            category_product: PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
            }),
            quantity: PropTypes.number,
            discount: PropTypes.string,
        }),
        product: PropTypes.shape({
            menu_product: PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
            }),
            quantity: PropTypes.number,
            discount: PropTypes.string,
        }),
        all_suggestions_count: PropTypes.number,
        onCloseModal: PropTypes.func,
        t: PropTypes.func.isRequired,
    };

    onButtonClick = () => {
        const { action, category, product, all_suggestions_count } = this.props;
        Order.log('preconfirmation warning product suggestion accepted', {
            product_suggestion: {
                action,
                category,
                product,
                all_suggestions_count,
            },
        });

        switch (this.props.action) {
            case 'show_product':
            case 'add_product': {
                const menu_products = Mobi2Go.Menu.getProducts();
                const menu_product = menu_products.getById(
                    this.props.product.menu_product.id
                );

                if (menu_product) {
                    const order_product = menu_product.createOrderProductInstance();

                    if (
                        this.props.product.modifiers &&
                        this.props.product.modifiers.length
                    ) {
                        order_product.setModifiers(
                            this.props.product.modifiers
                        );
                    }
                    const ignore_size_requirement =
                        this.props.product.modifiers.length > 0;

                    // Quick add to order and proceed? or show product modal and go back?
                    // We don't want to progress forward to confirmation if the customer must make multiple choices
                    if (
                        this.props.product.quantity === 1 &&
                        order_product.shouldQuickAddToOrder(
                            ignore_size_requirement
                        )
                    ) {
                        Mobi2Go.Order.addProduct(order_product);
                        this.props.closeModal(true);
                        UI.trigger(
                            'progressForward',
                            'preconfirmation_warning'
                        );
                    } else {
                        if (this.props.all_suggestions_count === 1) {
                            order_product.setQuantity(
                                this.props.product.quantity
                            );
                        }
                        this.props.closeModal(true);
                        UI.trigger('editProduct', order_product);
                    }
                }
                break;
            }
            case 'show_category': {
                this.props.closeModal();
                UI.trigger(
                    'showCategory',
                    this.props.category.menu_category.id
                );
                UI.trigger(
                    'scrollToCategory',
                    this.props.category.menu_category.id,
                    true
                );
                break;
            }
        }
    };

    render() {
        const { t } = this.props;
        let menu_item = null;

        if (this.props.category) {
            menu_item = Menu.getCategories().getById(
                this.props.category.menu_category.id
            );
        } else if (this.props.product) {
            menu_item = Menu.getProducts().getById(
                this.props.product.menu_product.id
            );
        }

        if (!menu_item) {
            return null;
        }

        return (
            <div
                data-item-name={menu_item.name}
                data-item={menu_item.id}
                className="m2g-preconfirmation-warning-product-suggestion"
                onClick={this.onButtonClick}
            >
                <div className="m2g-preconfirmation-warning-product-suggestion-image-container m2g-hidden">
                    <div className="m2g-preconfirmation-warning-product-suggestion-image-loading-placeholder m2g-hidden" />
                    {menu_item.image_src ? (
                        <img
                            className="m2g-preconfirmation-warning-product-suggestion-image m2g-image"
                            src={menu_item.image_src}
                        />
                    ) : (
                        <div className="m2g-preconfirmation-warning-product-suggestion-image--placeholder" />
                    )}
                </div>
                <div className="m2g-preconfirmation-warning-product-suggestion-name-and-description">
                    <div className="m2g-preconfirmation-warning-product-suggestion-name m2g-text--emphasise">
                        {menu_item.name}
                    </div>
                    <div
                        className="m2g-preconfirmation-warning-product-suggestion-description m2g-text--small"
                        dangerouslySetInnerHTML={{
                            __html: menu_item.description,
                        }}
                    />
                </div>
                <button
                    className={classNames(
                        'm2g-button',
                        'm2g-button--primary',
                        'm2g-text--small',
                        'm2g-preconfirmation-warning-product-suggestion-button'
                    )}
                >
                    {this.props.action === 'add_product' ? t('add') : t('view')}
                </button>
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.preconfirmation-warning')(
    ProductSuggestion
);
